var map = {
	"./hand-0.png": 3852,
	"./hand-1.png": 389,
	"./hand-2.png": 6382,
	"./hand-3.png": 5607,
	"./hand-4.png": 2968,
	"./hand-5.png": 4097,
	"./hand-6.png": 3514,
	"./hand-7.png": 8723,
	"./hand-8.png": 3428,
	"./hand-9.png": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1465;